import script from "./Checks.vue?vue&type=script&setup=true&lang=js"
export * from "./Checks.vue?vue&type=script&setup=true&lang=js"

import "./Checks.vue?vue&type=style&index=0&id=5bed12cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bed12cd"]])

export default __exports__